var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Graph Style/Bar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Graph-Style/Bar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,1.5 C11,1.22385763 11.2238576,1 11.5,1 L12.5,1 C12.7761424,1 13,1.22385763 13,1.5 L13,13 L14,13 L14,14 L0,14 L0,0 L1,0 L1,13 L2,13 L2,6.5 C2,6.22385763 2.22385763,6 2.5,6 L3.5,6 C3.77614237,6 4,6.22385763 4,6.5 L4,13 L5,13 L5,3.5 C5,3.22385763 5.22385763,3 5.5,3 L6.5,3 C6.77614237,3 7,3.22385763 7,3.5 L7,13 L8,13 L8,10.5 C8,10.2238576 8.22385763,10 8.5,10 L9.5,10 C9.77614237,10 10,10.2238576 10,10.5 L10,13 L11,13 L11,1.5 Z",
    id: "Combined-Shape",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/Bar.8127e7a513f8230891afab858b518d05.svg";
export { ForwardRef as ReactComponent };